import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { CacheService } from '../cache/cache.service';
import { SelectOption } from './select-option.model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Service that handles application configurations
 */
@Injectable()
export class ConfigService {

    constructor(
        private cache: CacheService,
        private translate: TranslateService,
    ) {}

    /**
     * Gets a list of all language options
     * @returns {Observable<SelectOption[]>}
     */
    getLanguageOptions(): Observable<SelectOption[]> {
        return of(
            [
                {
                    label: 'English',
                    value: 'en',
                },
                {
                    label: 'Français',
                    value: 'fr'
                }
            ],
        );
    }

    /**
     * Gets language label related to the specified value
     * @param value
     * @returns {Reducer}
     */
    getLanguageLabelFromValue(value: string): Observable<string> {
        return this.getLanguageOptions()
            .pipe(map((options: Array<SelectOption>) => {
                return this.getLabelFromValue(options, value);
            }));
    }

    /**
     * Map options to select options
     * @param selectOptions
     * @param label
     * @returns {any}
     */
    private getLabelFromValue(selectOptions: Array<SelectOption>, label: string): string {
        const option: SelectOption = _.find(selectOptions, (selectOption: SelectOption) => {
            return selectOption.value === label;
        });

        if (option) {
            return option.label;
        }
        return null;
    }

    private handleError(error: Response | any) {
        const returnedError = {
            code: '',
            errMsg: ''
        };

        if (error instanceof error) {
            const body = error.error.json() || '';
            const err = body.errorDescription || JSON.stringify(body);
            returnedError.code = body.code;
            returnedError.errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            returnedError.errMsg = error.message ? error.message : error.toString();
        }
        console.error(returnedError.errMsg);
        throw new Error(JSON.stringify(returnedError));
    }

}
